
import React from 'react';
import BaseComponent from './Base';
import { Line } from 'react-chartjs-2';
import DatePicker from 'react-datepicker2';

class ReportDownloads extends BaseComponent {
    constructor(props) {
      let config = {
        subModuleName : 'report/downloads',
        filterParams: []
      };
      super(props,config);
      var x = new Date();
      x.setMonth(x.getMonth()-1);

      this.state.extra_fields = {
        fromDate:this.getFormatedDateForDatePicker(null, x),
        toDate:this.getFormatedDateForDatePicker(null, new Date),
      }
      this.lockScreen();
      this.state.showConfig={
        email:true,
        mobile:true,
        direct:true,
        ip:true
      }
    }
    getSaleChartData(){
      let labels = [];
      let ip = [];
      let direct = [];
      let mobile = [];
      let email = [];

      this.state.data.requestsStatistics.forEach(e=>{
        
        var dateChanged = true;

        if (labels.length>0)
        {
          if (labels[labels.length-1] != this.g2j(e.date)) dateChanged = true
          else dateChanged = false;
        }

        //تاریخ عوض شده
        if (dateChanged)
        {
          ip.push(0);
          direct.push(0);
          mobile.push(0);
          email.push(0);
          labels.push(this.g2j(e.date));
        }

        if (e.mode === 2) mobile[mobile.length-1] += e.count;
        if (e.mode === 3) ip[ip.length-1] += e.count;
        if (e.mode === 5) direct[direct.length-1] += e.count;
        if (e.mode === 7) email[email.length-1] += e.count;
      });

      var datasets = [];
      if (this.state.showConfig.ip)
        datasets.push({
          label:'دریافتهای آی پی',
          fill: false,
          backgroundColor: '#39cccc',
          borderColor: '#39cccc',
          borderWidth: 1,
          hoverBackgroundColor: 'rgba(255,99,132,0.4)',
          hoverBorderColor: 'rgba(255,99,132,1)',
          data: ip
        });
      if (this.state.showConfig.ip)
        datasets.push();
      if (this.state.showConfig.direct)
        datasets.push({
          label:'دریافتهای مستقیم',
          fill: false,
          backgroundColor: '#f39c12',
          borderColor: '#f39c12',
          borderWidth: 1,
          hoverBackgroundColor: 'rgba(255,99,132,0.4)',
          hoverBorderColor: 'rgba(255,99,132,1)',
          data: direct
        });
      if (this.state.showConfig.mobile)
        datasets.push({
          label:'دریافتهای موبایلی',
          fill: false,
          backgroundColor: '#00a65a',
          borderColor: '#00a65a',
          borderWidth: 1,
          hoverBackgroundColor: 'rgba(255,99,132,0.4)',
          hoverBorderColor: 'rgba(255,99,132,1)',
          data: mobile
        });
      if (this.state.showConfig.email)
        datasets.push({
          label:'دریافتهای ایمیلی',
          fill: false,
          backgroundColor: '#605ca8',
          borderColor: '#605ca8',
          borderWidth: 1,
          hoverBackgroundColor: 'rgba(255,99,132,0.4)',
          hoverBorderColor: 'rgba(255,99,132,1)',
          data: email
        });

      var bardata = {
        labels: labels,
        datasets:datasets
      };
      return bardata;
    }
    setDateFrom(e){
      this.state.extra_fields.fromDate = e;
      this.refresh();
    }
    setDateTo(e){
      this.state.extra_fields.toDate = e;
      this.refresh();
    }
    renderStatisticBoxs(){
      return (
        <div className="box box-warning">
          <div className="box-header with-border">
            <h3 className="box-title reportDl">گزارش دریافتی های کل مرکز به تفکیک نوع دسترسی ها از تاریخ&nbsp;
              <DatePicker
                inputReadOnly={true}
                className="form-control"
                placeholder={"از تاریخ"}
                isGregorian={false}
                showTodayButton={true}
                timePicker={false}
                onChange={(e) => { this.setDateFrom(e) }}
                value={this.state.extra_fields.fromDate}
              />
              &nbsp;تا تاریخ&nbsp;
              <DatePicker
                inputReadOnly={true}
                className="form-control"
                placeholder={"تا تاریخ"}
                isGregorian={false}
                showTodayButton={true}
                timePicker={false}
                onChange={(e) => { this.setDateTo(e) }}
                value={this.state.extra_fields.toDate}
              />
            </h3>
          </div>
          <div className="box-body no-padding">
            <div>
              <Line data={this.getSaleChartData()} options={{
                legend: { display: true, },
                scales: {
                  yAxes: [{
                    ticks: {
                        fontFamily:'IRANSans',
                        beginAtZero: true
                    }
                  }],
                  xAxes: [{
                    ticks: {
                        fontFamily:'IRANSans'
                    }
                  }]
                }
              }} />                
            </div>
            <div className="text-center mr-5">
              <input defaultChecked={this.state.showConfig.ip} onChange={e=>{
                this.state.showConfig.ip = e.target.checked;
                this.setState({showConfig:this.state.showConfig})
              }} type="checkbox" /> درخواستهای آی پی&nbsp;
              <input defaultChecked={this.state.showConfig.ip} onChange={e=>{
                this.state.showConfig.direct = e.target.checked;
                this.setState({showConfig:this.state.showConfig})
              }} type="checkbox" /> درخواستهای مستقیم&nbsp;
              <input defaultChecked={this.state.showConfig.ip} onChange={e=>{
                this.state.showConfig.mobile = e.target.checked;
                this.setState({showConfig:this.state.showConfig})
              }} type="checkbox" /> درخواستهای موبایلی&nbsp;
              <input defaultChecked={this.state.showConfig.ip} onChange={e=>{
                this.state.showConfig.email = e.target.checked;
                this.setState({showConfig:this.state.showConfig})
              }} type="checkbox" /> درخواستهای ایمیلی
            </div>
          </div>
        </div>
      )
    }
    getTotal(mode=0){
      var count = 0;
      this.state.data.requestsStatistics.forEach(e=>{
        if (e.mode === mode || mode === 0) count += e.count;
      });
      return count;
    }
    render() {
      if (this.state.data === null || this.state.data === undefined)
        return this.showLoading();
      if (this.state.data.status === 500 || this.state.data.status === 0)
        return this.render500()
      if (this.state.data.status === 404)
        return this.render404()
      if (this.state.data.status === 2)
        return this.renderNoAccess();
      if (this.state.data.status === 4)
        return this.renderNoLogin();
      return(
        <div className="row">
          <div className="col-md-10">
            {this.renderStatisticBoxs()}
          </div>
          <div className="col-md-2">
            <div>
                
              <div className="col-md-12">
                <div className="small-box bg-aqua">
                  <div className="inner">
                    <h3>{this.money(this.getTotal())}</h3>
                    <p>کل دریافتی</p>
                  </div>
                  <div className="icon"><i class="fal fa-download"></i></div>
                </div>
              </div>

              <div className="col-md-12">
                <div className="small-box bg-teal">
                  <div className="inner">
                    <h3>{this.money(this.getTotal(3))}</h3>
                    <p>دریافتی آی پی</p>
                  </div>
                  <div className="icon"><i class="fal fa-router"></i></div>
                </div>
              </div>

              <div className="col-md-12">
                <div className="small-box bg-green">
                  <div className="inner">
                    <h3>{this.money(this.getTotal(2))}</h3>
                    <p>دریافتی دسترسی موبایل</p>
                  </div>
                  <div className="icon"><i className="fas fa-mobile-android-alt"></i></div>
                </div>
              </div>

              <div className="col-md-12">
                <div className="small-box bg-purple">
                  <div className="inner">
                    <h3>{this.money(this.getTotal(7))}</h3>
                    <p>دریافتی دسترسی ایمیل</p>
                  </div>
                  <div className="icon"><i className="fal fa-at"></i></div>
                </div>
              </div>

              <div className="col-md-12">
                <div className="small-box bg-yellow">
                  <div className="inner">
                    <h3>{this.money(this.getTotal(5))}</h3>
                    <p>دریافتی مستقیم</p>
                  </div>
                  <div className="icon"><i class="fal fa-file-export"></i></div>
                </div>
              </div>

            </div>

          </div>       
          
        </div>
      )
    }
  }
  export default ReportDownloads;